import { yellow, red, orange, green } from "@mui/material/colors";

export default {
  primary: {
    main: "#2b3b57",
    buttonSelected: "#242a45",
    iconMain: "#353d63",
    iconSelected: "#EAA138",
    white: "#ffffff",
  },
  secondary: {
    main: "#d6ff59",
    contrastText: "#ffffff",
  },
  escalating: {
    main: red[700],
    contrastText: "#fff",
  },
  controlled: {
    main: green[700],
    contrastText: "#000",
  },
  minor: {
    main: yellow[700],
    contrastText: "#000",
  },
  moderate: {
    main: orange[700],
    contrastText: "#000",
  },
  major: {
    main: red[700],
    contrastText: "#fff",
  },
  remediated: {
    main: green[700],
    contrastText: "#fff"
  },
  notifications: {
    main: '#FF3333',
    observation: '#353D63',
    leak: '#ED6C02',
  }
};
